module.exports = __webpack_public_path__ + "static/media/tablet_view_grey.206c9517.svg";